"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stylingUtils = require("../../services/stylingUtils");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));
    _this.checkbox = null;
    _this.state = {
      randomId: _this._generateId()
    };

    _this.setCheckboxRef = function (element) {
      _this.checkbox = element;
    };

    return _this;
  }

  _createClass(Checkbox, [{
    key: "_generateId",
    value: function _generateId() {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
    }
  }, {
    key: "_getClassNames",
    value: function _getClassNames() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        "rhe-checkbox": true,
        "indeterminate": this.props.indeterminate,
        "disabled": this.props.disabled
      });
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      if (!this.props.disabled) {
        e.stopPropagation();
        this.props.onClick.bind(this);
        this.checkbox.checked = !this.checkbox.checked;
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(e) {
      e.stopPropagation();
      this.props.onChange.bind(this);
      this.checkbox.checked = !this.checkbox.checked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          indeterminate = _this$props.indeterminate,
          props = _objectWithoutProperties(_this$props, ["children", "indeterminate"]);

      return _react.default.createElement("div", {
        className: "rhe_checkbox__container",
        "aria-labelledby": this.props.id || this.state.randomId
      }, _react.default.createElement("div", {
        className: "rhe_checkbox--hover"
      }), _react.default.createElement("input", _extends({
        ref: this.setCheckboxRef,
        type: "checkbox",
        id: this.props.id || this.state.randomId,
        indeterminate: typeof indeterminate === 'boolean' ? indeterminate.toString() : indeterminate
      }, props)), _react.default.createElement("label", {
        htmlFor: this.props.id || this.state.randomId,
        className: this._getClassNames()
      }, children));
    }
  }]);

  return Checkbox;
}(_react.default.Component);

exports.default = Checkbox;
Checkbox.defaultProps = {
  onClick: function onClick() {},
  onChange: function onChange() {},
  disabled: false,
  indeterminate: false
};
Checkbox.propTypes = {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(["true", "false"])]),
  indeterminate: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(["true", "false"])])
};